module.exports = __webpack_public_path__ + "img/2.a70d3696.png";